//Form
import { Formik, useField, Form } from "formik";
import * as Yup from "yup";

//CSS Related
import { css } from "@emotion/react";
import BarLoader from "react-spinners/BarLoader";
import { motion } from "framer-motion";

//Component / Hooks
import { useState } from "react";
import useHttp from "../../hooks/useHttp";
import classes from "./Login.module.css";
import { ButtonPrimary } from "../../components/Button/Button";
import { Link } from "react-router-dom";

const override = css`
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 50%);
`;

const MyTextInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label htmlFor={props.id || props.name}>{label}</label>
      <input className="text-input" {...field} {...props} />
      {meta.touched && meta.error ? (
        <div className={classes.error}>{meta.error}</div>
      ) : null}
    </>
  );
};

const Login = () => {
  const firebasePost = useHttp();
  const [isLoading, setIsLoading] = useState(false);

  const content = (
    <Form className={classes.login}>
      <h3 className={classes.login__title}>登入</h3>
      <MyTextInput
        name="email"
        type="email"
        className={classes.login__input}
        placeholder="信箱"
      />
      <MyTextInput
        name="password"
        type="password"
        className={classes.login__input}
        placeholder="密碼"
      />
      <ButtonPrimary
        text="登入"
        type="submit"
        className={`${classes.login__button}`}
      />
      <div className={classes.alternative}>
        <Link to="forgetPassword">
          <span className={classes.alternative__text}>忘記密碼</span>
        </Link>
        <Link to="/signup">
          <span className={classes.alternative__text}>加入會員</span>
        </Link>
      </div>
    </Form>
  );

  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      validationSchema={Yup.object({
        email: Yup.string().email("請填寫正確的信箱").required("必填"),
        password: Yup.string()
          .required("必填")
          .min(6, "密碼必須大於6位字元")
          .matches(
            /^(?=.*[a-z])(?=.*[0-9])(?=.{6,})/,
            "密碼必須由英文及數字所組成"
          ),
      })}
      onSubmit={(values, { setSubmitting }) => {
        setIsLoading(true);
        const status = firebasePost("LOGIN", {
          email: values.email,
          password: values.password,
        });
        if (status === "SUCCESS") setIsLoading(false);
      }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0, transition: { duration: "0.1" } }}
        className={classes.login__container}
      >
        {!isLoading && content}
        {isLoading && <BarLoader color="#EA4949" css={override} size={150} />}
      </motion.div>
    </Formik>
  );
};

export default Login;
